import { useEffect, useState } from 'react'

/** The longest a deferred call waits for the browser to go idle */
export const afterFirstScreenTimeoutMs = 2000

/** Once the first screen has been idle, later mounts (route changes) need not wait again */
let isPastFirstScreen = false

/** For tests: back to a fresh page load */
export const resetAfterFirstScreen = () => {
  isPastFirstScreen = false
}

/**
 * False until the browser is first idle after the first render, then true for the rest of the page's life (GH #2903).
 * For calls the first screen does not show, such as the push key and the export runs: they wait until the first
 * screen's own calls are under way instead of joining their wave. Without `requestIdleCallback` (Safari before 18.4)
 * they wait the timeout.
 */
export const useAfterFirstScreen = () => {
  const [isAfter, setIsAfter] = useState(isPastFirstScreen)
  useEffect(() => {
    if (isAfter) {
      return
    }
    const done = () => {
      isPastFirstScreen = true
      setIsAfter(true)
    }
    if (typeof requestIdleCallback === 'function') {
      const id = requestIdleCallback(done, { timeout: afterFirstScreenTimeoutMs })
      return () => cancelIdleCallback(id)
    }
    const id = setTimeout(done, afterFirstScreenTimeoutMs)
    return () => clearTimeout(id)
  }, [isAfter])
  return isAfter
}
